import * as $ from 'jquery';
import 'slick-carousel';
import ViewportTracker from '../lib/ViewportTracker';
import * as variables from '../variables.js';

const carouselBreakpoint: any = variables.screen_premierhqCarouselStack;

const premierhqCarousel = () => {
	$('.premierhqPackage__carousel--1').slick({
		mobileFirst: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
		dots: true,
		appendDots: $('.premierhqPackage--1'),
		pauseOnHover: false,
		pauseOnDotsHover: false,
		waitForAnimate: false,
		fade: true,
		responsive: [{
			breakpoint: carouselBreakpoint.substr(0, carouselBreakpoint.length - 2),
			settings: {
				asNavFor: $('.premierhqPackage__carousel--2'),
				customPaging: (slider: any, i: number) => {
					const dotHeading = slider.$slides.eq(i).find('.premierhqPackageStat__heading').text();
					const dotText = slider.$slides.eq(i).find('.premierhqPackageStat__text').text();
					return '<button type="button" class="slickDot"><strong class="slickDot__heading">' + dotHeading + '</strong>' + (dotText ? ('<span class="slickDot__text">' + dotText + '</span>') : '') + '</button>';
				}
			}
		  }]
	});
	$('.premierhqPackage__carousel--2').slick({
		mobileFirst: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
		dots: true,
		appendDots: $('.premierhqPackage--2'),
		pauseOnHover: false,
		pauseOnDotsHover: false,
		waitForAnimate: false,
		fade: true,
		responsive: [{
			breakpoint: carouselBreakpoint.substr(0, carouselBreakpoint.length - 2),
			settings: {
				asNavFor: $('.premierhqPackage__carousel--1'),
				customPaging: (slider: any, i: number) => {
					const dotHeading = slider.$slides.eq(i).find('.premierhqPackageStat__heading').text();
					const dotText = slider.$slides.eq(i).find('.premierhqPackageStat__text').text();
					return '<button type="button" class="slickDot"><strong class="slickDot__heading">' + dotHeading + '</strong>' + (dotText ? ('<span class="slickDot__text">' + dotText + '</span>') : '') + '</button>';
				}
			}
		  }]
	});


	if (ViewportTracker.below('premierhqCarouselStack', true)) {
		const carousel1SlideCount = parseInt($('.premierhqDemo').data('carousel-1-slides'));
		const carousel2SlideCount = parseInt($('.premierhqDemo').data('carousel-2-slides'));
		const totalSlideCount = carousel1SlideCount + carousel2SlideCount;

		// Remove Carousel 2 slides from Carousel 1
		for (let index = totalSlideCount; index > carousel2SlideCount; index--) {
			$('.premierhqPackage__carousel--1').slick('slickRemove', index, true);
		}

		// Remove Carousel 1 slides from Carousel 2
		for (let index = 0; index < carousel1SlideCount; index++) {
			$('.premierhqPackage__carousel--2').slick('slickRemove', 1, true);
		}
	}
};

export default premierhqCarousel;